<template>
  <div>
    <nav aria-label="breadcrumb" class="breadcrumb-nav border-0 mb-0">
      <div class="container d-flex align-items-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/dashboard">Home</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="'/casi-clinici/show/' + formClinicalCase.slug">Torna al caso</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Aggiorna {{ formClinicalCase.name }}
          </li>
        </ol>
      </div>
      <!-- End .container -->
    </nav>
    <h4 class="checkout-title text-center mt-0 mb-2" style="font-size: 3.2rem" v-if="draft == false">
      Aggiorna il caso clinico
    </h4>
    <h4 class="checkout-title text-center mt-0 mb-2" style="font-size: 3.2rem" v-if="draft == true">
      Concludi il caso
    </h4>
    <div class="checkout">
      <div class="container">
        <div class="row pb-4">
          <div class="col-lg-12">
            <LoadedComponent :loading="loading" :percentual="percentual" />

            <AlertComponent :message="success" :alert-type="'success'" />
            <AlertComponent :message="errorMessage" :alert-type="'danger'" />

            <ul class="nav nav-tabs nav-tabs-bg" id="tabs-1" role="tablist" v-if="!loading">
              <li class="nav-item">
                <a class="nav-link active" id="tab-1-tab" data-toggle="tab" href="#tab-1" role="tab"
                  aria-controls="tab-1" aria-selected="true">Dati del caso</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-2-tab" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2"
                  aria-selected="true">Ordinamento allegati</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-3-tab" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3"
                  aria-selected="true">Carica allegati</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-4-tab" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-4"
                  aria-selected="true">Carica la copertina</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="tab-5-tab" data-toggle="tab" href="#tab-5" role="tab" aria-controls="tab-5"
                  aria-selected="true" v-if="!formClinicalCase.allusers">
                  Accessibilita Caso
                </a>
              </li>
            </ul>

            <div class="tab-content tab-content-border" id="tab-content-1" v-if="!loading">
              <div class="tab-pane fade show active bg-white" id="tab-1" role="tabpanel" aria-labelledby="tab-1-tab">
                <form class="pt-2 pr-4 pl-4" id="form-date-submit" @submit.prevent="update_clinical_case">
                  <h4 class="pb-2" v-if="draft == false">
                    <small>
                      Inserisci o aggiorna le informazioni del tuo caso e fai
                      click nel bottone in basso a destra "Salva le info" per
                      memorizzare
                    </small>
                  </h4>

                  <p class="text-center">
                    <span v-if="formClinicalCase.allusers">
                      Questo caso è visibile a tutti gli utenti</span>
                    <span v-else>
                      Questo caso è visibile solo agli utenti inclusi nella
                      scheda "Accessibilita Caso"</span>
                  </p>
                  <div class="col-md-12 text-center mt-2" v-if="draft == true">
                    <h6>Pubblicazione caso</h6>
                    <div class="form-check form-check-inline mr-4">
                      <input class="form-check-input" type="radio" name="draft" id="draft_false"
                        v-model="formClinicalCase.draft" :value="false" />
                      <label class="form-check-label" for="draft_false">Pubblica caso a tutti (Verranno inviate le
                        notifiche
                        agli utenti)</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="draft" id="draft_true" :value="true"
                        v-model="formClinicalCase.draft" />
                      <label class="form-check-label" for="draft_true">Salva il caso in bozze</label>
                    </div>
                  </div>
                  <div class="row">
                    <div :class="draft === false ? 'col-sm-12' : 'col-sm-6'">
                      <label for="nome_caso">Nome del caso *</label>
                      <input type="text" class="form-control" name="nome" id="nome_caso"
                        placeholder="Aggiorna il nome del caso" v-model="formClinicalCase.name" />

                      <div class="alert alert-danger" v-if="errors.name">
                        {{ errors.name[0] }}
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <label for="nome_caso">Data pubblicazione *</label>
                      <input type="date" class="form-control" name="data_pubblicazione" id="data_pubblicazione_edit"
                        v-model="formClinicalCase.publish_date" :min="new Date().toJSON().slice(0, 10)" required />
                      <div class="alert alert-danger" v-if="errors.publish_date">
                        {{ errors.publish_date[0] }}
                      </div>
                    </div>
                    <!-- End .col-sm-6 -->

                    <div class="col-md-6">
                      <label for="categorie_mediche_edit" class="form-label">Categoria *</label>
                      <select class="form-control" id="categorie_mediche_edit" name="id_categoria_medica"
                        v-model="formClinicalCase.category_medical_id" readonly>
                        <option v-for="category in categoryMedical" :key="category.id" :value="category.id">
                          {{ category.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.category_medical_id">
                        {{ errors.category_medical_id[0] }}
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label for="distretto_anatomico" class="form-label">Distretto Anatomico *</label>
                      <select class="form-control" id="distretto_anatomico" name="id_distretto"
                        v-model="formClinicalCase.anatomical_district_id" required>
                        <option v-for="anatomical in anatomicalDistrict" :key="anatomical.id" :value="anatomical.id">
                          {{ anatomical.name }}
                        </option>
                      </select>

                      <div class="alert alert-danger" v-if="errors.anatomical_district_id">
                        {{ errors.anatomical_district_id[0] }}
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <h5 class="card-title text-center mb-1">Trattamenti</h5>
                      <p class="mb-2 text-center">Seleziona i trattamenti</p>
                      <div class="row">
                        <div v-for="patology in patologies" :key="patology.id" class="col-md-2">
                          <!-- Categoria con icona per aprire/chiudere -->
                          <div class="mb-1">
                            <input type="checkbox" v-model="formClinicalCase.patologies" :value="patology.id" :checked="formClinicalCase.patologies.includes(
                              patology.id
                            )
                              " />
                            {{ patology.name }}
                          </div>

                          <!-- Sottocategorie sovrapposte -->
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <label for="descrizione">Descrizione del post *</label>
                      <textarea class="form-control" id="descrizione" rows="3" name="descrizione"
                        placeholder="Spiegazione del tuo post" v-model="formClinicalCase.description"></textarea>

                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                    </div>
                  </div>

                  <div class="row flex-column pb-2 pl-2 pr-2">
                    <div class="flex-row mt-4">
                      <button type="submit" class="btn btn-primary float-right ml-3">
                        Salva <i class="las la-save"></i>
                      </button>
                      <button type="button" class="btn btn-info float-right "
                        @click="openModalNotification('info_caso')">
                        Salva e invia una notifica<i class="las la-save"></i>
                      </button>


                    </div>
                  </div>
                </form>
              </div>

              <div class="tab-pane fade show bg-white" id="tab-2" role="tabpanel" aria-labelledby="tab-2-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">

                    <h2 class="checkout-title" style="font-size: 2rem">
                      Ordinamento file
                      <br />
                      <small>TRASCINA I FILE PER CAMBIARE L’ORDINE</small>
                    </h2>

                    <form @submit.prevent="save_order">

                      <ul ref="sortableList" class="list-group">

                        <li v-for="(item, index) in attachments" :key="item.id"
                          class="list-group-item mb-2 d-flex align-items-center justify-content-between">

                          <div class="d-flex align-items-center w-75">

                            <i class="las la-grip-lines drag-handle mr-3"></i>

                            <input type="text" v-model="item.name" class="form-control" />

                            <button type="button" class="btn btn-link ml-2" @click="rename(item)">
                              <i class="las la-pen-fancy"></i>
                              Rinomina
                            </button>

                          </div>

                          <button type="button" class="btn btn-danger btn-sm" @click="deleteAttachment(item.id, index)">
                            Elimina
                          </button>

                        </li>

                      </ul>

                      <div class="row flex-column pb-2 pl-2 pr-2 mt-3">
                        <div class="flex-row">

                          <button type="submit" class="btn btn-primary float-right">
                            Salva ordinamento
                            <i class="las la-save"></i>
                          </button>

                        </div>
                      </div>

                    </form>

                  </div>
                </div>
              </div>
              <div class="tab-pane fade show bg-white" id="tab-3" role="tabpanel" aria-labelledby="tab-3-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica allegati
                    </h2>
                    <p>
                      Seleziona i tuoi file e confermali facendo click su "Invia
                      file"
                    </p>

                    <!-- End .checkout-title -->
                    <form @submit.prevent="upload_attachments">
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="files[]" ref="fileInput"
                            @change="handleFileUpload" id="fileInput" aria-describedby="inputGroupFileAddon01"
                            multiple />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInput" id="labelsfiles">{{
                          nameFiles }}
                        </label>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row">

                          <button type="submit" class="btn btn-primary float-right ml-3">
                            Salva<i class="las la-save"></i>
                          </button>
                          <button type="button" class="btn btn-info float-right  "
                            @click="openModalNotification('allegati_caso')">
                            Salva e invia una notifica<i class="las la-save"></i>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade show bg-white" id="tab-4" role="tabpanel" aria-labelledby="tab-4-tab">
                <div class="row pt-4 pr-4 pl-4">
                  <div class="col-md-12">
                    <h2 class="checkout-title" style="font-size: 2rem">
                      Carica la copertina del caso <br /><small>Seleziona il tuo file
                      </small>
                    </h2>
                    <!-- End .checkout-title -->
                    <form>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <input type="file" class="custom-file-input" name="cover" ref="fileInputCover"
                            @change="handleFileUploadCover" id="fileInputCover"
                            aria-describedby="inputGroupFileAddon01" />
                        </div>
                        <label class="custom-file-label text-center labels-files" for="fileInputCover"
                          id="labelsfiles">{{
                            nameFiles }}
                        </label>
                      </div>

                      <div class="d-flex justify-content-center" v-if="coverAttachment !== null">
                        <img :src="coverAttachment.path" :alt="coverAttachment.name" class="img-thumbnail" />
                      </div>
                      <div class="text-center mt-2" v-if="coverAttachment !== null">
                        <button type="button" class="btn btn-danger" @click="deleteAttachment(this.coverAttachment.id)">
                          <i class="las la-trash"></i>
                        </button>
                      </div>

                      <!--d-none -->
                      <a href="#tab-1" id="cover-neurohub" class="btn btn-link d-none" role="tab" aria-controls="tab-1"
                        aria-selected="true" data-toggle="tooltip" data-placement="left"
                        title="Puoi ricontrallare i dati del tuo caso e scegliere una copertina fra le immagini che hai appena caricato">Fra
                        le immagini che hai appena caricato vuoi dare una
                        copertina al caso clinico? Se si clicca qui.</a>
                      <div class="row flex-column pb-2 pl-2 pr-2">
                        <div class="flex-row"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div class="tab-pane fade show bg-white" id="tab-5" role="tabpanel" aria-labelledby="tab-5-tab"
                v-if="!formClinicalCase.allusers">
                <div class="row pt-4 pr-4 pl-4">
                  <button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#add-user">
                    Aggiungi utente
                  </button>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Nome utente</th>
                        <th scope="col">Gruppo</th>
                        <th scope="col">tag</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-if="formClinicalCase.activity_views">
                      <tr v-for="(view, index) in formClinicalCase.activity_views" :key="index">
                        <td>{{ view.user.full_name }}</td>
                        <td v-if="view.group">{{ view.group.name ?? "" }}</td>
                        <td v-else></td>
                        <td>{{ view.user.full_name }}</td>
                        <td>
                          <button type="button" class="btn btn-danger btn-sm">
                            <i class="las la-trash-alt" @click="deleteViews(view)"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="add-user" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Aggiungi utente
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="addUsersVisibility">
              <div class="modal-body">
                <div class="row m-4">
                  <div class="col-md-3" v-for="user in users" :key="user.id">
                    <ul>
                      <li>
                        <div class="icheck-wetasphalt mt-3">
                          <input type="checkbox" :id="'chb1-' + user.id" :value="user.id" v-model="addUsers" />
                          <label :for="'chb1-' + user.id">{{
                            user.full_name
                          }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button type="submit" class="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
      id="message-create-modal">
      <div class="modal-dialog modal-xl" role="document" style="max-width: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <div class="w-100">
              <h5 class="modal-title text-center">Scrivi il messaggio</h5>
            </div>
          </div>
          <div class="modal-body p-4">
            <form @submit.prevent="newsclinicalcase">

              <div class="form-group">
                <QuillEditor v-model:content="newsletterform.message" contentType="html" theme="snow" :options="options"
                  style="height: 300px" />
              </div>

              <div class="alert alert-danger" v-if="errors.message">
                {{ errors.message[0] }}
              </div>
              <div class="form-footer">
                <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                  INVIA
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import httpservices from "@/services/httpservices.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import { QuillEditor } from "@vueup/vue-quill";
import { useAuth } from "@/stores/auth.js";
import { useToast } from "vue-toast-notification";
import Sortable from "sortablejs";
import router from "@/router";
import * as bootstrap from "bootstrap";

export default {
  name: "UpdateClinicalCase",

  props: ["slug"],

  components: {
    LoadedComponent,
    AlertComponent,
    QuillEditor
  },

  data() {
    return {

      loading: true,

      today: new Date().toISOString().split("T")[0],

      nameFiles: "Scegli i file (MAX 1GB)",

      patologies: [],
      categoryMedical: [],
      anatomicalDistrict: [],

      attachments: [],
      coverAttachment: null,

      selectedFiles: [],

      users: [],
      addUsers: [],

      success: "",
      errorMessage: "",
      errors: {},

      percentual: 0,

      sortableInstance: null,

      draft: false,

      formClinicalCase: {
        id: null,
        slug: "",
        name: "",
        publish_date: "",
        description: "",
        category_medical_id: null,
        anatomical_district_id: null,
        patologies: [],
        draft: false,
        allusers: false,
        activity_views: []
      },

      newsletterform: {
        message: "",
        id: null
      },

      submitNavClick: null,

      options: {
        theme: "snow",
        placeholder: "Scrivi il messaggio da comunicare agli utenti"
      }

    };
  },

  async mounted() {
    await this.initializePage();
  },

  beforeUnmount() {
    if (this.sortableInstance)
    {
      this.sortableInstance.destroy();
    }
  },

  methods: {

    async initializePage() {

      this.loading = true;

      await Promise.all([
        this.fetchPatology(),
        this.fetchAtomicalDistrict()
      ]);

      await this.getClinicalCase();

      this.loading = false;
    },

    async rename(item) {

      try
      {

        const response = await httpauth.post("/attachments/rename", {
          id: item.id,
          name: item.name
        });

        const toast = useToast();

        toast.open({
          message: response.data.message,
          type: "success",
          position: "top-right"
        });

      } catch (error)
      {

        const toast = useToast();

        toast.open({
          message: error.response?.data?.message || "Errore rinomina file",
          type: "error",
          position: "top-right"
        });

      }

    },



    async getClinicalCase() {

      try
      {

        const response = await httpauth.get(`/casi-clinici/edit/${this.slug}`);
        const data = response.data.data;

        this.formClinicalCase = {
          ...data,
          publish_date: data.publish_date
            ? data.publish_date.split("T")[0]
            : this.today,
          patologies: data.patologies ? data.patologies.map(p => p.id) : [],
          activity_views: data.activity_views || []
        };

        this.draft = this.formClinicalCase.draft;

        await Promise.all([
          this.loadAttachment(this.formClinicalCase.id),
          this.fetchUsers(),
          this.fetchCategoryMedical()
        ]);

      } catch (error)
      {

        this.handleAuthError(error);

        this.errors = error.response?.data?.errors || {};
        this.errorMessage = error.response?.data?.message || "Errore caricamento caso";

      }
    },



    async fetchCategoryMedical() {

      const response = await httpservices.getCategoryMedical();

      const categoryId = this.formClinicalCase.category_medical_id;

      if (categoryId === 3)
      {
        this.categoryMedical = response.data.data.filter(c => c.id === 3);
      } else
      {
        this.categoryMedical = response.data.data;
      }

    },



    async fetchPatology() {

      const response = await httpservices.getPatology();
      this.patologies = response.data.data;

    },



    async fetchAtomicalDistrict() {

      const response = await httpservices.getAnatomicalDistrict();
      this.anatomicalDistrict = response.data.data;

    },



    async fetchUsers() {

      const response = await httpauth.get(`/activity-view/excluded/${this.formClinicalCase.id}`);
      this.users = response.data.data;

    },



    async update_clinical_case() {

      try
      {

        const response = await httpauth.put(
          `/casi-clinici/${this.formClinicalCase.id}`,
          this.formClinicalCase
        );

        const toast = useToast();

        toast.open({
          message: response.data.message,
          type: "success",
          position: "top-right"
        });

        router.push("/casi-clinici/");

      } catch (error)
      {

        this.errors = error.response?.data?.errors || {};
        this.errorMessage = error.response?.data?.message;

      }

    },



    async loadAttachment(model_id) {

      const response = await httpauth.post("/attachments/show", {
        model: "activity",
        model_id
      });

      this.attachments = response.data.data;

      const coverIndex = this.attachments.findIndex(a => a.cover);

      if (coverIndex !== -1)
      {
        this.coverAttachment = this.attachments.splice(coverIndex, 1)[0];
      }

      this.$nextTick(() => {

        setTimeout(() => {

          const list = this.$refs.sortableList;

          if (!list) return;

          if (this.sortableInstance)
          {
            this.sortableInstance.destroy();
          }

          this.sortableInstance = new Sortable(list, {

            animation: 150,

            handle: ".drag-handle",

            ghostClass: "sortable-ghost",

            onEnd: (evt) => {

              const item = this.attachments.splice(evt.oldIndex, 1)[0];

              this.attachments.splice(evt.newIndex, 0, item);

            }

          });

        }, 200);

      });

    },



    async save_order() {

      try
      {

        const order = this.attachments.map(a => a.id);

        const response = await httpauth.post("/attachments/reorder", {
          model: "activity",
          model_id: this.formClinicalCase.id,
          order: order
        });

        const toast = useToast();

        toast.open({
          message: response.data.message,
          type: "success",
          position: "top-right"
        });

      } catch (error)
      {

        const toast = useToast();

        toast.open({
          message: error.response?.data?.message || "Errore salvataggio ordine",
          type: "error",
          position: "top-right"
        });

      }

    },



    handleFileUpload(event) {

      const files = Array.from(event.target.files);

      if (!files.length) return;

      const totalSize = files.reduce((s, f) => s + f.size, 0);

      if (totalSize > 1024 * 1024 * 1024)
      {
        alert("La dimensione totale supera 1GB");
        return;
      }

      this.selectedFiles = files;
      this.nameFiles = files.map(f => f.name).join(", ");

    },



    async upload_attachments() {

      if (!this.selectedFiles.length) return;

      this.loading = true;
      this.percentual = 0;

      try
      {

        const response = await httpservices.uploadAttachments(
          this.selectedFiles,
          this.formClinicalCase.id,
          "activity",
          0,
          p => this.percentual = p
        );

        this.loading = false;

        if (response.data.status)
        {

          this.success = response.data.message;
          this.selectedFiles = [];
          this.nameFiles = "Scegli i file (MAX 1GB)";

          await this.loadAttachment(this.formClinicalCase.id);

        }

      } catch (error)
      {

        this.loading = false;
        this.errorMessage = "Errore caricamento allegati";

      }

    },



    async deleteAttachment(id, index = null) {

      await httpservices.deleteAttachment(id);

      if (index !== null)
      {
        this.attachments.splice(index, 1);
      } else
      {
        this.coverAttachment = null;
      }

    },



    async deleteViews(view) {

      await httpauth.delete(`/activity-view/${view.user_id}/${view.activity_id}`);

      this.formClinicalCase.activity_views =
        this.formClinicalCase.activity_views.filter(v =>
          v.user_id !== view.user_id
        );

    },



    validatePublishDate(event) {

      const input = event.target;

      if (input.value < this.today)
      {
        input.setCustomValidity("La data non può essere precedente ad oggi");
      } else
      {
        input.setCustomValidity("");
      }

    },
    openModalNotification(type) {

      this.submitNavClick = type;

      const modalElement = document.getElementById("message-create-modal");

      if (!modalElement) return;

      const modal = new bootstrap.Modal(modalElement);

      modal.show();

    },

    async newsclinicalcase() {

      try
      {

        if (this.submitNavClick === "info_caso")
        {
          await this.update_clinical_case();
        }

        if (this.submitNavClick === "allegati_caso")
        {
          await this.upload_attachments();
        }

        this.newsletterform.id = this.formClinicalCase.id;

        const response = await httpauth.post(
          `/casi-clinici/${this.formClinicalCase.id}/notifica-aggiornamento`,
          this.newsletterform
        );

        const toast = useToast();

        toast.open({
          message: response.data.message,
          type: "success",
          position: "top-right"
        });

        const modalElement = document.getElementById("message-create-modal");

        if (modalElement)
        {
          const modal = bootstrap.Modal.getInstance(modalElement);
          modal.hide();
        }

        router.push("/casi-clinici/");

      } catch (error)
      {

        this.errors = error.response?.data?.errors || {};

      }

    },



    handleAuthError(error) {

      if (
        error.response?.status === 401 &&
        error.response?.data?.message === "Unauthenticated."
      )
      {
        const auth = useAuth();
        auth.clearToken();
        window.location.href = "/";
      }

    }

  }
};
</script>

<style scoped>
.nav-tabs .nav-link {
  border-radius: 8px 8px 0 0;
  font-weight: 500;
}

.nav-tabs .nav-link.active {
  background: #eaf4ff;
  color: #007bff;
}

.btn-primary {
  padding: 10px 20px;
  font-weight: 600;
}

.btn-info {
  background: #4da3ff;
}

.list-group-item {
  border-radius: 8px;
  border: 1px solid #eee;
}

.drag-handle {
  cursor: grab;
  font-size: 20px;
  color: #999;
}

.drag-handle:active {
  cursor: grabbing;
}

.sortable-ghost {
  opacity: 0.4;
}

.drag-handle {
  cursor: grab;
  font-size: 20px;
  color: #888;
}

.drag-handle:active {
  cursor: grabbing;
}

.sortable-ghost {
  opacity: 0.3;
}
</style>